import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {ScreenDetectorService} from '../service/screen-detector.service';
import {ScreenTypeEnum} from '../@absract/@enums/screenType.enum';
import {debounceTime, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {ScreenDetectorAnswer} from "../@absract/@interface/IConfig.interface";
import {Subject} from "rxjs";

@Directive({ selector: '[mz-screen-detector]' }) //
export class ScreenDetectorDirective implements OnInit, OnDestroy {

  /**
   * */
  @Input('mzDebounceTime') public mzDebounceTime? = 250;

  /**
   * */
  @Output('mzScreenChange') public mzScreenChange: EventEmitter<ScreenDetectorAnswer> = new EventEmitter<ScreenDetectorAnswer>();

  /**
   * */
  private alive$: Subject<void> = new Subject();

  constructor(
    private renderer: Renderer2,
    private hostElement: ElementRef,
    private cdRef: ChangeDetectorRef,
    private screenDetector: ScreenDetectorService
  ) {
    // this.zone.runOutsideAngular(
    //     () => {
    //       screenDetector.subscription$
    //         .pipe(
    //             debounceTime(this.mzDebounceTime),
    //             distinctUntilChanged((prev, curr) => prev.type === curr.type),
    //             // takeWhile(() => this.alive)
    //             takeUntil(this.alive$)
    //         )

            this.screenDetector.getSubscription(
              this.mzDebounceTime,
              this.alive$,
              true
            )
            .subscribe(
          screen => {
            /*
            * delete classes
            * */
            for (const screenTypeEnumKey in ScreenTypeEnum) {
              renderer.removeClass(
                hostElement.nativeElement,
                screenDetector.getClassName(ScreenTypeEnum[screenTypeEnumKey])
              );
            }

            /*
            * add new class
            * */
            renderer.addClass(
              hostElement.nativeElement,
              screenDetector.getClassName(screen.type)
            );

            this.mzScreenChange.emit(screen);
            this.cdRef.markForCheck();
          }
        );
    //     }
    // )
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.alive$.next();
    this.alive$.unsubscribe();
  }
}
